import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { translateFormFieldLabel, translateFormFieldValue } from '../../../../../../helpers/collaborativeIndexations'

class Gender extends Component
{
    static propTypes = {
        t: PropTypes.func.isRequired,
        updateFieldValue: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
        hasFocus: PropTypes.bool,
    }

    constructor(props)
    {
        super(props)

        this.handleOnChange = this.handleOnChange.bind(this)
        this.mainField = React.createRef()
    }

    componentDidMount()
    {
        if(this.props.hasFocus === true)
        {
            this.mainField.current.focus()
        }
    }

    handleOnChange(event)
    {
        this.props.updateFieldValue("gender", event.target.value)
    }

    render()
    {
        const { t, fields } = this.props

        return (
            <div className={"form-group"}>
                <label>{translateFormFieldLabel(t, "gender")}</label>
                <div className={"form-radio"}>
                    <input ref={this.mainField} defaultChecked={fields.gender === "male"} onChange={this.handleOnChange} type={"radio"} name={"gender"} id={"genderMale"} value={"male"}/>
                    <label htmlFor={"genderMale"}>{translateFormFieldValue(t, "gender", "male")}</label>
                </div>
                <div className={"form-radio"}>
                    <input defaultChecked={fields.gender === "female"}  onChange={this.handleOnChange} type={"radio"} name={"gender"} id={"genderFemale"} value={"female"}/>
                    <label htmlFor={"genderFemale"}>{translateFormFieldValue(t, "gender", "female")}</label>
                </div>
            </div>
        )
    }
}

export default withTranslation()(Gender)
